import { render, staticRenderFns } from "./adEffectiveDateComponentNews.vue?vue&type=template&id=673e95fc&"
import script from "./adEffectiveDateComponentNews.vue?vue&type=script&lang=js&"
export * from "./adEffectiveDateComponentNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports